import styled, { CSSProperties, css } from "styled-components";
import { useContentMargins } from "@songtradr-one/components-frontend";

// TEXT

// STYLES
export const PageContainer = styled.div<Props>(({ $gap = "2rem" }) => {
  const [margin] = useContentMargins();
  return css`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${$gap};
    padding: 3rem 0;
    margin: 0 ${margin} 0 ${margin};
  `;
});

// DATA

// TYPES
type Props = {
  $gap?: CSSProperties["gap"];
};

// CONSTANTS

// FUNCTIONS

// ASSETS
